import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);


import { routes } from './routes';

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
});

router.beforeEach((to, from, next) => {
  const currentUser = sessionStorage.getItem('auth');

  let adminUser ,  empleadoInternoUser = false;

  if (currentUser) {
    const admin = JSON.parse(currentUser).role.roles.find(el => el.name === 'Administrador');
    if (admin) adminUser = Object.values(admin).length

    const empleadoInterno = JSON.parse(currentUser).role.roles.find(el => el.name === 'Empleado interno');
    if (empleadoInterno) empleadoInternoUser = Object.values(empleadoInterno).length

  }
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const onlyAdmin = to.matched.some(record => record.meta.onlyAdmin);
  const almostOneRole = to.matched.some(record => record.meta.almostOneRole);
  const almostAdmin = to.matched.some(record => record.meta.almostAdmin);
  const almostEmpleadoInterno = to.matched.some(record => record.meta.almostEmpleadoInterno);

  if (currentUser && almostOneRole && !( (almostAdmin == (adminUser>0)) || (almostEmpleadoInterno  == (empleadoInternoUser>0)) ) ) next('/siniestros');
  else if (currentUser && !adminUser && onlyAdmin) next('/login');
  else if (requiresAuth && !currentUser) next('/login');
  else if (!requiresAuth && currentUser) next('/');
  else next();
});

export default router;
